<template>
    <div class="row card-form">
        <div class="col xl12 l12 m12 s12 multiselect-field">
            <label>Bandeira do cartão</label>
            <multiselect
                v-model="form.paymentCompanyCode"
                placeholder="Selecione a bandeira do cartão"
                :options="cardOptions"
                :options-limit="300"
                :allow-empty="false"
                :searchable="false"
                :multiple="false"
                :select-label="select2Options.selectLabel"
                :selected-label="select2Options.selectedLabel"
                :deselect-label="select2Options.deselectLabel"
                ref="value"
                :show-no-results="false"
                label="title"
                track-by="value"
            ></multiselect>
            <div class="error" v-show="$v.form.paymentCompanyCode.$dirty && !$v.form.paymentCompanyCode.required">
                Esse campo é obrigatório.
            </div>
        </div>
        <div class="input-field-grid col xl12 l12 m12 s12">
            <div class="input-field">
                <eg-input
                    type="text"
                    title="Nome do titular do cartão"
                    placeholder-text="Nome do titular do cartão"
                    v-model.trim="form.holderName"
                    :value="form.holderName"
                    :rules="textRules"
                    :valid="valid"
                    @valid="textRules.valid = $event"
                    :error="error"
                    :errorMessage="capitalizeText(erros.holder_name)"
                />
            </div>
            <div class="input-field">
                <eg-input
                    type="text"
                    title="Nº do cartão"
                    placeholder-text="Nº do cartão"
                    v-model.trim="form.cardNumber"
                    :value="form.cardNumber"
                    :mask="['####-####-####-####']"
                    :rules="textRules"
                    :valid="valid"
                    @valid="textRules.valid = $event"
                    :error="error"
                    :errorMessage="capitalizeText(erros.card_number)"
                />
            </div>
            <div class="input-field">
                <eg-input
                    type="text"
                    title="Código de segurança"
                    placeholder-text="Código de segurança"
                    v-model.trim="form.cardCvv"
                    :value="form.cardCvv"
                    :mask="[this.form.paymentCompanyCode.value === 'american_express' ? '####' : '###']"
                    :rules="textRules"
                    :valid="valid"
                    @valid="textRules.valid = $event"
                    :error="error"
                    :errorMessage="capitalizeText(erros.card_cvv)"
                />
            </div>
            <div class="input-field">
                <eg-input
                    type="text"
                    title="Data de expiração"
                    placeholder-text="Data de expiração"
                    v-model.trim="form.cardExpiration"
                    :value="form.cardExpiration"
                    :mask="['##/####']"
                    :rules="textRules"
                    :valid="valid"
                    @valid="textRules.valid = $event"
                    :error="error"
                    :errorMessage="capitalizeText(erros.card_expiration)"
                />
            </div>
        </div>
        <div class="col xl12 l12 m12 s12">
            <eg-button
                variant="eg-blue"
                type="button"
                block
                @click="sendFormCard"
                class="button-send"
                :loading="loadingBtn"
                :disabled="loadingBtn"
                :error="error"
            >
                Cadastrar Cartão
            </eg-button>
        </div>
    </div>
</template>
<script>
import { capitalizeText } from '@/utils';
import { required } from 'vuelidate/lib/validators';
export default {
    name: 'CardForm',
    data: () => ({
        form: {
            holderName: '',
            cardExpiration: '',
            cardNumber: '',
            cardCvv: '',
            paymentCompanyCode: ''
        },
        erros: {
            card_expiration: '',
            card_number: '',
            card_cvv: '',
            holder_name: ''
        },
        cardOptions: [
            { title: 'MasterCard', value: 'mastercard' },
            { title: 'Visa', value: 'visa' },
            { title: 'American Express', value: 'american_express' },
            { title: 'Diners Club', value: 'diners_club' },
            { title: 'Elo', value: 'elo' },
            { title: 'Hipercard', value: 'hipercard' },
            { title: 'JBC', value: 'jbc' }
        ],
        select2Options: {
            selectLabel: 'Selecionar',
            selectedLabel: 'Selecionar',
            deselectLabel: 'Desmarcar'
        },
        valid: false,
        textRules: {
            name: '',
            type: 'text',
            required: true,
            valid: true
        }
    }),
    props: {
        loadingBtn: {
            type: Boolean,
            default: false
        },
        error: {
            type: Boolean,
            default: false
        },
        errorMessage: {
            type: Array
        }
    },
    methods: {
        capitalizeText,
        async sendFormCard() {
            this.valid = !this.valid;
            await setTimeout(() => {}, 1000);
            this.$v.form.paymentCompanyCode.$touch();
            if (this.textRules.valid && !this.$v.form.paymentCompanyCode.$invalid) {
                const form = await this.formatForm();
                this.$emit('cardForm', form);
            }
            this.erros.card_expiration = '';
            this.erros.card_number = '';
            this.erros.card_cvv = '';
            this.erros.holder_name = '';
        },
        formatForm() {
            const form = {
                holderName: this.form.holderName,
                cardExpiration: this.form.cardExpiration,
                cardNumber: this.form.cardNumber.replace(/-/gi, ''),
                cardCvv: this.form.cardCvv,
                paymentCompanyCode: this.form.paymentCompanyCode.value
            };
            return form;
        },
        setErrors() {
            this.errorMessage.forEach(element => {
                this.erros[element.parameter] = element.message;
            });
        }
    },
    validations: {
        form: {
            paymentCompanyCode: {
                required
            }
        }
    },
    watch: {
        error: {
            deep: true,
            handler() {
                this.setErrors();
            }
        }
    }
};
</script>
<style scoped>
.card-form {
    padding: 12px 12px 32px 12px;
    background-color: #f9f9f9;
    border: 1px solid #dbdbdb;
    border-radius: 3px;
    margin: 0;
}
.button-send {
    margin-top: 30px;
}
::v-deep .input-component {
    max-height: 42px;
}
.multiselect-field {
    margin-top: 16px;
}

.multiselect-field ::v-deep .multiselect {
    margin-top: 3px !important;
}

.multiselect-field label {
    margin-left: 5px;
    margin-bottom: 5px;
    font-size: 14px;
    color: black;
}

.multiselect-field ::v-deep .multiselect__tags {
    border-radius: 3px;
}

.input-field-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
    margin-top: 1rem;
}

.input-field-grid .input-field {
    margin-top: 0px;
}

.input-field-grid .input-field .input-component ~ p {
    margin-bottom: 0px !important;
}

@media only screen and (max-width: 1024px) {
.input-field-grid {
    grid-template-columns: 1fr;
}
}
</style>
